import script from "./TravelView.vue?vue&type=script&setup=true&lang=js"
export * from "./TravelView.vue?vue&type=script&setup=true&lang=js"

import "./TravelView.vue?vue&type=style&index=0&id=63cb9ef9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63cb9ef9"]])

export default __exports__